type HeartIconProps = {
  size?: number;
  filled?: boolean;
  className?: string;
};

export const HeartIcon = ({
  size = 35,
  filled = false,
  className,
}: HeartIconProps) => {
  const path =
    "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 " +
    "2 5.42 4.42 3 7.5 3 " +
    "9.24 3 10.91 3.81 12 5.09 " +
    "13.09 3.81 14.76 3 16.5 3 " +
    "19.58 3 22 5.42 22 8.5 " +
    "22 12.28 18.6 15.36 13.45 20.04 " +
    "L12 21.35z";

  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
    >
      <path
        d={path}
        fill={filled ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
};
